import React, { useEffect, useRef } from 'react';
import { TableRow, TableCell, Box, CircularProgress } from '@mui/material';

interface LoadingRowProps {
  loadMoreCallback: () => void;
  totalWidth: number;
  colSpan: number;
}

const LoadingRow: React.FC<LoadingRowProps> = ({ loadMoreCallback, totalWidth, colSpan }) => {
  const loadingRef = useRef<HTMLTableRowElement>(null);

  useEffect(() => {
    const element = loadingRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadMoreCallback();
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    observer.observe(element);
    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [loadMoreCallback]);

  return (
    <TableRow ref={loadingRef}>
      <TableCell colSpan={colSpan} align="center">
        <Box width={totalWidth} display="flex" justifyContent="center" py={2}>
          <CircularProgress />
        </Box>
      </TableCell>
    </TableRow>
  );
};

export default LoadingRow;
